import { put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';

import type Immutable from 'immutable';
import { alertRulesSelectors } from '.';
import type { CoreActionCreator } from '../core/resourceStoreTypes';
import * as actions from './alertRulesActions';
import { getLastSyncDate } from './alertRulesSelectors';
import { AlertRule, type AlertRuleProps, mkAlertRule } from './alertRulesTypes';

const mkQcsSyncAlertRulesConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<AlertRuleProps>();

const mkResourceConfig = (successAction: CoreActionCreator<any, any>, failureAction: CoreActionCreator<any, any>) =>
  mkQcsSyncAlertRulesConfig({
    resourceName: 'alertRule',
    resourceBaseUrl: '/alert/alert-rules',
    getLastSyncDate,
    successAction,
    failureAction,
    transformResponseToResources: (response) => response?.data?.resources?.map((data) => mkAlertRule(data)),
  });

export function* getAlertRulesActionWatcher() {
  yield takeEvery(
    actions.getAlertRules.type,
    resourceSagaUtils.qcsSyncGetResources<AlertRuleProps>,
    mkResourceConfig(actions.getAlertRulesSuccess, actions.getAlertRulesFailure),
  );
}

export function* updateAlertRuleActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.updateAlertRuleSuccess, actions.updateAlertRuleFailure);
  yield takeEvery(
    actions.updateAlertRule.type,
    resourceSagaUtils.qcsSyncUpdateResource<AlertRuleProps>,
    resourceConfig,
  );
}

export function* pauseAlertRuleActionWatcher() {
  yield takeLatest(actions.pauseAlertRules, function* ({ payload: shouldPause, meta }) {
    const alertRulesMap: Immutable.Map<string, AlertRule> = yield select(alertRulesSelectors.getAllAlertRules);
    const alertRules =
      alertRulesMap
        ?.map((rule) => rule.setIn(['preferences', 'isEnabled'], !shouldPause))
        ?.valueSeq()
        .toArray() ?? [];
    yield put(actions.batchAlertRules(alertRules, meta));
  });
}

export function* batchAlertRulesActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.batchAlertRulesSuccess, actions.batchAlertRulesFailure);
  yield takeEvery(
    actions.batchAlertRules.type,
    resourceSagaUtils.qcsSyncUpdateResources<AlertRuleProps>,
    resourceConfig,
  );
}

export default [
  updateAlertRuleActionWatcher,
  getAlertRulesActionWatcher,
  batchAlertRulesActionWatcher,
  pauseAlertRuleActionWatcher,
];
